import LazyLoad from 'vanilla-lazyload';

// eslint-disable-next-line no-unused-vars
var lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy'
  // ... more custom settings?
});